(() => {
  if (window.nualaProductEnhancementsLoaded) return;
  window.nualaProductEnhancementsLoaded = true;
  const rootUrl = window.Shopify?.routes?.root || '/';
  const init = () => {
    document.querySelectorAll('[data-nuala-pick-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const card = form.closest('[data-nuala-pick]');
      const group = form.closest('.nuala-picks');
      const select = form.querySelector('select[name="id"]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        card.querySelector('[data-pick-price]').textContent = option.dataset.price || '';
        const image = card.querySelector('.nuala-pick__image img');
        if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
        const compare = card.querySelector('[data-pick-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        card.querySelector('[role="status"]').textContent = '';
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.busy || !form.reportValidity()) return;
        const id = form.elements.id.value;
        if (!id) return;
        const button = form.querySelector('button');
        const status = card.querySelector('[role="status"]');
        form.dataset.busy = 'true';
        button.disabled = true;
        status.textContent = '';
        try {
          const response = await fetch(rootUrl + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || group.dataset.errorLabel);
          status.textContent = group.dataset.addedLabel;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles:true,detail:{product:data.items?.[0] || data,addToCartBtn:button}}));
        } catch (error) {
          status.textContent = error.message || group.dataset.errorLabel;
        } finally {
          delete form.dataset.busy;
          button.disabled = false;
        }
      });
    });
    document.querySelectorAll('[data-nuala-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      const main = document.getElementById(bar.dataset.mainId);
      const form = document.getElementById(bar.dataset.formId);
      const mainButton = form?.querySelector('[data-add-to-cart]');
      if (!main || !form || !mainButton) return;
      bar.dataset.ready = 'true';
      const variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
      const selectors = [...bar.querySelectorAll('[data-sticky-option]')];
      const button = bar.querySelector('[data-sticky-submit]');
      let current = null;
      let passedButton = false;
      let wasBusy = false;
      const update = () => {
        const values = selectors.map(select => select.value);
        const complete = values.every(Boolean);
        current = selectors.length ? variants.find(variant => variant.options.every((value,index) => value === values[index])) : variants[0];
        button.disabled = complete && (!current || !current.available);
        button.textContent = !complete ? bar.dataset.chooseLabel : !current ? bar.dataset.unavailableLabel : !current.available ? bar.dataset.soldLabel : bar.dataset.addLabel;
        bar.querySelector('[data-sticky-selection]').textContent = complete && selectors.length ? values.join(' / ') : '';
        if (current) {
          bar.querySelector('[data-sticky-price]').textContent = current.price;
          const image = bar.querySelector('.nuala-sticky__image img');
          if (image && current.image) { image.src = current.image; image.removeAttribute('srcset'); }
          const compare = bar.querySelector('[data-sticky-compare]');
          compare.textContent = current.compare;
          compare.hidden = !current.compare;
        }
      };
      const showOptions = () => {
        const index = Math.max(0,selectors.findIndex(select => !select.value));
        const control = main.querySelector('[data-variant-input][data-index="option' + (index+1) + '"]');
        const target = control?.closest('.variant-wrapper') || mainButton;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        const focus = target.querySelector('select,input:not([type="hidden"]),button') || mainButton;
        focus.focus({preventScroll:true});
      };
      const visibility = () => {
        const cartOpen = document.documentElement.classList.contains('js-drawer-open') || document.body.classList.contains('js-drawer-open') || !!document.querySelector('#kaching-cart[aria-hidden="false"],.kaching-cart--open');
        const hide = !passedButton || cartOpen;
        if (bar.hidden !== hide) bar.hidden = hide;
        if (document.body.classList.contains('nuala-sticky-active') === hide) document.body.classList.toggle('nuala-sticky-active',!hide);
        if (!hide) document.body.style.setProperty('--nuala-sticky-height',bar.offsetHeight+'px');
      };
      selectors.forEach((select,index) => select.addEventListener('change', () => {
        const candidates = [...main.querySelectorAll('[data-variant-input][data-index="option' + (index+1) + '"]')];
        const source = candidates.find(input => input.tagName === 'SELECT' || input.value === select.value);
        if (source && select.value) {
          if (source.type === 'radio') source.click();
          else {source.value = select.value;source.dispatchEvent(new Event('change',{bubbles:true}));}
        }
        update();
      }));
      main.addEventListener('change', event => {
        const source = event.target.closest('[data-variant-input]');
        if (!source) return;
        const index = Number(source.dataset.index.replace('option','')) - 1;
        if (selectors[index]) selectors[index].value = source.value;
        update();
      });
      button.addEventListener('click', () => {
        if (selectors.some(select => !select.value) || !current) {showOptions();return;}
        const actual = form.querySelector('[name="id"]')?.value;
        if (String(current.id) !== String(actual)) {showOptions();return;}
        if (!current.available || mainButton.disabled) return;
        mainButton.click();
      });
      new MutationObserver(() => {
        const busy = mainButton.classList.contains('btn--loading');
        if (busy) {button.disabled=true;wasBusy=true;}
        else if (wasBusy) {wasBusy=false;update();}
      }).observe(mainButton,{attributes:true,attributeFilter:['class','disabled']});
      const observer = new IntersectionObserver(entries => {
        passedButton = entries[0].boundingClientRect.bottom <= 0;
        visibility();
      },{threshold:0});
      observer.observe(mainButton);
      new MutationObserver(visibility).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
      new MutationObserver(visibility).observe(document.body,{attributes:true,attributeFilter:['class']});
      window.addEventListener('resize',visibility,{passive:true});
      document.addEventListener('shopify:section:unload',event => {if(event.target.contains(main)){observer.disconnect();document.body.classList.remove('nuala-sticky-active');}});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
